<script setup>
// import FooterComponent from "@/components/FooterComponent.vue";
// import HeaderComponent from "@/components/HeaderComponent.vue";
import { showToast } from "@/composables/toast";
import { useSessionMessageStore } from "@/stores/sessionMessage";
import { useToast } from "primevue";
import { onMounted, watch } from "vue";
import { RouterView } from "vue-router";

const messageStore = useSessionMessageStore();
const toast = useToast();

onMounted(() => {
  if (messageStore.hasMessage) {
    showToast(toast, messageStore.getMessageType, messageStore.getMessageType);
    messageStore.cleanMessage();
  }
});

watch(() => messageStore.hasMessage, (hasMessage) => {
  if (hasMessage) {
    showToast(toast, messageStore.message, messageStore.getMessageType);
    messageStore.cleanMessage();
  }
});

</script>

<template>
  <div class="h-screen bg-light-white">
    <!-- <HeaderComponent :type="'auth'" /> -->

    <section class="flex justify-center flex-col h-full">
        <RouterView />
    </section>

    <!-- <FooterComponent :type="'auth'" /> -->
  </div>
</template>
